/* eslint-disable react/no-find-dom-node */

import noop from 'lodash/noop'
import React from 'react'
import ReactDOM from 'react-dom'

import { SmileIcon } from 'shared/components/icon'
import ElasticInput from 'shared/components/input/ElasticInput'
import { EmojiPicker } from 'shared/components/picker'
import './SmsInput.scss'

type SmsInputProps = {
  allowEmoji?: boolean
  autoFocus?: boolean
  icons?: boolean
  name?: string
  value?: string
  minRows?: number
  maxRows?: number
  maxLength?: number
  disabled?: boolean
  onChange?(...args: unknown[]): unknown
}

type SmsInputState = {
  style: { height: string }
  emojiOpen: boolean
  selection: { start: number; end: number }
}

class SmsInput extends React.PureComponent<SmsInputProps, SmsInputState> {
  input: any
  constructor(props: any) {
    super(props)
    this.state = {
      style: { height: '26px' },
      emojiOpen: false,
      selection: {
        start: 0,
        end: 0,
      },
    }
    this.input = React.createRef()
  }

  submitOnEnter = (e: any) => {
    if (e.which === 13) {
      e.preventDefault()
      if (e.target.form) {
        e.target.form.dispatchEvent(new Event('submit', { cancelable: true }))
      }
    }
  }

  openEmoji = () => {
    // @ts-expect-error findDOMNode is removed from @types/react-dom 19 but still works at runtime
    const inputNode = ReactDOM.findDOMNode(this.input.current)
    const { selection } = this.state
    this.setState({
      emojiOpen: true,
      selection: {
        start: inputNode?.selectionStart || selection.start,
        end: inputNode?.selectionEnd || selection.end,
      },
    })
  }

  closeEmoji = () => this.setState({ emojiOpen: false })

  selectEmoji = (e: any) => {
    const emoji = e.native
    const { start, end } = this.state.selection
    const { value, name } = this.props
    const safeValue = value ?? ''
    let newValue = safeValue.substring(0, start) + emoji
    newValue += safeValue.substring(end)
    const pos = start + emoji.length
    const newSelection = { start: pos, end: pos }
    this.input.current.value = newValue
    this.props.onChange?.({ target: { value: newValue, name } })
    this.setState({ selection: newSelection, emojiOpen: false })
  }

  onHeightChange = (height: any) => {
    const { icons } = this.props
    const padding = icons ? 40 : 0
    this.setState({ style: { height: `${height + padding + 6}px` } })
  }

  render() {
    const { name, value, minRows, maxRows, icons, maxLength, autoFocus, disabled, onChange, allowEmoji } = this.props
    const { emojiOpen } = this.state
    return (
      <div className={`SmsInput-main ${disabled ? ' disabled' : ''}`}>
        <div className="SmsInput-wrap" style={this.state.style}>
          <ElasticInput
            // @ts-expect-error TS(2769): No overload matches this call.
            autoFocus={autoFocus}
            disabled={disabled}
            maxLength={maxLength || Number.MAX_SAFE_INTEGER}
            maxRows={maxRows}
            minRows={minRows}
            name={name}
            onChange={onChange}
            onHeightChange={this.onHeightChange}
            ref={this.input}
            spellCheck={false}
            value={value}
          />
          {icons && (
            <div className="SmsInput-icons">
              {/* @ts-expect-error TS(2769): No overload matches this call. */}
              {allowEmoji && <SmileIcon className="SmsInput-icons-smile" onClick={this.openEmoji} size={20} />}
              {emojiOpen && (
                <EmojiPicker
                  onOuterClick={this.closeEmoji}
                  onSelect={this.selectEmoji}
                  rootStyle={{ top: '-25px', left: '25px' }}
                />
              )}
            </div>
          )}
        </div>
        {maxLength && <div className="SmsInput-remaining">{`Remaining: ${maxLength - (value ?? '').length}`}</div>}
      </div>
    )
  }
}

// @ts-expect-error TS(2339): Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
SmsInput.defaultProps = {
  autoFocus: false,
  icons: true,
  name: 'SmsInput',
  value: '',
  minRows: 3,
  maxRows: 6,
  maxLength: 255,
  disabled: false,
  onChange: noop,
}

export default SmsInput
